<template>
  <div class="page">
    <Top />
    <Banner />
    <ProductList @change="path" />
    <Popup />
  </div>
</template>
<script>
import Top from './components/Top.vue'
import Popup from './components/Popup.vue'
import Banner from './components/Banner.vue'
import ProductList from './components/ProductList.vue'
import { BRAND } from './constant/brand'
import { isInWxMP } from "@/util";
import _ from "lodash";

const isMiniApp = isInWxMP()
export default {
  components: {
    Top,
    Popup,
    Banner,
    ProductList
  },
  methods: {
    // 跳转详情
    path (type, prodId) {
      if (isMiniApp) {
        // 小程序环境跳转
        this.miniAppPath(type, prodId);
      } else {
        // 微信h5环境跳转
        this.wxH5Path(type, prodId);
      }
    },
    // 跳转小程序详情
    miniAppPath (brand, prodId) {
      // 组装商详路径
      const path = this.getMiniAppHref(brand);
      // 组装商详品牌样式
      const query = this.getMiniAppQuery(brand, prodId);
      // 组装小程序路径
      const url = path + "?" + query
      if (brand === BRAND.MANTO) {
        window.wx.miniProgram.navigateTo({
          url: `/pages/webview/jump?appId=wx295fb795503abb3c&miniPath=${encodeURIComponent(url)}`
        });
      } else {
        if (window.wx) {
          if (_.isEmpty(window.wx.miniProgram))
            return window.wx.navigateTo({ url });
          return window.wx.miniProgram.navigateTo({ url });
        } else if (window.tt) {
          return window.tt.miniProgram.navigateTo({ url });
        } else if (xhs) {
          return xhs.miniProgram.navigateTo({ url });
        }
      }
    },
    // 微信h5跳转
    wxH5Path (type, prodId) {
      const appName = this.getMiniAppName(type);
      const path = this.getMiniAppHref(type);
      const query = this.getMiniAppQuery(type, prodId);
      window.location.href = `${process.env.VUE_APP_COMMIN_LINK}/index.html#/wxUrlScheme?appName=${appName}&path=${encodeURIComponent(path)}&query=${encodeURIComponent(query)}`;
    },
    // 组装小程序渠道枚举
    getMiniAppName (brand) {
      // 海马体小程序
      if ([BRAND.BLUE, BRAND.MASTER, BRAND.LAB].includes(brand)) return "himo_app";
      // MANTO小程序
      if (brand === BRAND.MANTO) return "mantu_mini_program";
    },
    // 组装产品详情路径
    getMiniAppHref (brand) {
      // 蓝标商详路径
      if ([BRAND.BLUE, BRAND.MASTER, BRAND.LAB].includes(brand)) return "/pagesA/product/prodDetail/index";
      // MANTO商详路径
      if (brand === BRAND.MANTO) return "/pages/product/product";
    },
    // 组装商详样式标识
    getMiniAppQuery (brand, prodId) {
      if ([BRAND.BLUE, BRAND.MASTER, BRAND.LAB].includes(brand)) {
        return `brand=${brand === BRAND.MASTER ? "gold" : "blue"}&showPid=${prodId}&pickPid=${prodId}`
      }
      if (brand === BRAND.MANTO) return `id=${prodId}`
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  background-color: rgba(111, 0, 11, 1);
}
</style>
